<template>
    <div>
        <div v-if="bill.state === 'COMPLETED'">
            <h3 class="text-5 text-center mb-3">ZESA Purchase Receipt</h3>
            <div class="row">
                <p class="col-sm-6 text-muted text-sm-left mb-0 mb-sm-3">Token : </p>
                <p class="col-sm-6"><strong>{{ bill.token_extended }}</strong></p>
            </div>

            <div class="row">
                <p class="col-sm-6 text-muted text-sm-left mb-0 mb-sm-3">Meter : </p>
                <p class="col-sm-6">{{ bill.meter }}</p>
            </div>

            <div class="row">
                <p class="col-sm-6 text-muted text-sm-left mb-0 mb-sm-3">Tender Amount : </p>
                <p class="col-sm-6">{{ bill.amount }}</p>
            </div>

            <div class="row">
                <p class="col-sm-6 text-muted text-sm-left mb-0 mb-sm-3">Customer Name : </p>
                <p class="col-sm-6">{{ bill.name }}</p>
            </div>

            <div class="row">
                <p class="col-sm-6 text-muted text-sm-left mb-0 mb-sm-3">Customer Address : </p>
                <p class="col-sm-6">{{ bill.address }}</p>
            </div>
            <div class="row">
                <p class="col-sm-6 text-muted text-sm-left mb-0 mb-sm-3">Receipt : </p>
                <p class="col-sm-6">{{ bill.receiptNumber }}</p>
            </div>

            <div class="row">
                <p class="col-sm-6 text-muted text-sm-left mb-0 mb-sm-3">Date : </p>
                <p class="col-sm-6">{{ bill.created_at }}</p>
            </div>

            <div class="row">
                <p class="col-sm-6 text-muted text-sm-left mb-0 mb-sm-3">Tariff :</p>
                <p class="col-sm-6">{{ bill.tariff }}</p>
            </div>
            <div class="row">
                <p class="col-sm-6 text-muted text-sm-left mb-0 mb-sm-3">Energy : </p>
                <p class="col-sm-6">KwH {{ bill.energyBought }} </p>
            </div>
            <div class="row">
                <p class="col-sm-6 text-muted text-sm-left mb-0 mb-sm-3">Energy Charge : </p>
                <p class="col-sm-6">ZWG {{ bill.energyCharge / 100 }}</p>
            </div>
            <div class="row">
                <p class="col-sm-6 text-muted text-sm-left font-weight-500 mb-0 mb-sm-3">Levy : </p>
                <p class="col-sm-6 font-weight-500">ZWG {{ bill.vatAmount / 100 }}</p>
            </div>
            <div class="row">
                <p class="col-sm-6 text-muted text-sm-left font-weight-500 mb-0 mb-sm-3">Transaction Reference : </p>
                <p class="col-sm-6 font-weight-500">{{ transaction.customer_reference }}</p>
            </div>
            <div v-if="transaction.payment_type ==='App\\EcocashPayment'" class="row">
                <p class="col-sm-6 text-muted text-sm-left font-weight-500 mb-0 mb-sm-3">Payment Reference : </p>
                <p class="col-sm-6 font-weight-500">{{ payment.ecocash_reference }}</p>
            </div>
            <div class="row align-items-center justify-content-center" v-if="bill.pdf">
                <p class="col-sm-6 text-muted text-sm-left font-weight-500 mb-0 mb-sm-3">Download : </p>
                <p class="col-sm-6 font-weight-500">
                    <a target="_blank" class="btn btn-success btn-sm" :href="`/zesa/receipt/${transaction.ref}`">
                        <i class="fas fa fa-download mr-1"></i> Download Receipt
                    </a>
                </p>
            </div>

        </div>
        <div v-if="init || bill.state === 'GENERATING-TOKEN'">
            <h3 class="text-5 text-center mb-5">Generating Token ... </h3>
            <div
                class="text-center text-primary text-20 line-height-07 mb-5 d-flex justify-content-center align-items-center">
                <div class="loader"></div>
            </div>
            <p v-if="countDown > 0" class="text-center text-primary text-8 line-height-07 mb-5">
                {{ this.countDown }}
            </p>
            <p class="text-center text-4 mb-5">Your Payment was successful we are generating your ZESA Token</p>
            <p v-if="" class="text-center text-1">To quickly check progress click below.</p>
        </div>
        <div v-if="bill.state === 'TOKEN-FAILED'">
            <h3 class="text-center text-6 mb-4 text-center">ZESA Purchase Failure </h3>

            <p class="text-center mb-4">
                Dear Customer, we regret any inconvenience from the disrupted ZESA transaction. Your unique reference
                number, {{ transaction.customer_reference }}, enables you to track the transaction's status at your convenience using the
                "<a href="/transaction/check"><strong>Check Previous Transaction Status</strong></a>" on the ZESA page. Following {{ reverseTimeout }} hours of inactivity, a
                transaction reversal option will become available. We appreciate your understanding and your continued
                trust in Magetsi for your bill payments.
            </p>

            <p>
                We advise customers not to retry after a failed transaction, and that any further tries will be treated as separate and intended transactions.
            </p>

            <div v-if="transaction.payment_type ==='App\\EcocashPayment'" class="row">
                <p class="col-sm-6 text-muted text-sm-left font-weight-500 mb-0 mb-sm-3">Payment Reference : </p>
                <p class="col-sm-6 font-weight-500">{{ payment.ecocash_reference }}</p>
            </div>

            <div v-if="transaction.payment_type === 'App\\EcocashPayment' && showReverse" class="row">
                <div class="text-center col-lg-12">
                    <button @click.prevent="reverse" class="btn btn-link">Reverse Transaction</button>
                </div>
            </div>
        </div>
        <div v-if="bill.state === 'ABORTED'">
            <h3 class="text-5 text-center mb-5">ZESA Purchase Cancelled </h3>

            <p class="text-center text-4 mb-5">
                Your ZESA transaction has been successfully cancelled, and your funds returned to your account.
            </p>
            <div class="row">
                <p class="col-sm-6 text-muted text-sm-left font-weight-500 mb-0 mb-sm-3">Transaction Reference : </p>
                <p class="col-sm-6 font-weight-500">{{ transaction.customer_reference }}</p>
            </div>
            <div v-if="transaction.payment_type ==='App\\EcocashPayment'" class="row">
                <p class="col-sm-6 text-muted text-sm-left font-weight-500 mb-0 mb-sm-3">Payment Reference : </p>
                <p class="col-sm-6 font-weight-500">{{ payment.ecocash_reference }}</p>
            </div>
        </div>
        <div class="form-group">
            <div class="row">
                <div class="col-md-6">
                    <button @click.prevent="submit"
                            :class="['btn btn-primary btn-block' , loading ? 'btn-loading' : '']">Refresh
                    </button>
                </div>
                <div class="col-md-6">
                    <router-link to="/bundles" class="btn btn-outline-primary btn-block">Close</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ecocash.vue",
    data() {
        return {
            reverseTimeout: 0,
            bill: {},
            payment: {},
            transaction: {},
            loading: false,
            init: true,
            showReverse: false,
            countDown: 5,
            ref: this.$route.query.id
        };

    },
    methods: {

        reverse() {
            this.loading = true;
            window.axios['post'](`${window.location.origin}/zesa/transaction/reverse`, {
                ref: this.ref
            }).then((response) => {

                this.init = false;
                if (response.data.success) {
                    this.bill = response.data.body.bill;
                    this.payment = response.data.body.payment;
                    this.transaction = response.data.body.transaction;
                }

            }).finally(() => {
                this.loading = false;
            });

        },

        submit() {
            if (this.loading) {
                return;
            }

            this.loading = true;
            this.countDown = 0;

            // Check Payment

            window.axios['post'](`${window.location.origin}/zesa/token`, {
                ref: this.ref
            }).then((response) => {

                this.init = false;
                if (response.data.success) {
                    this.bill = response.data.body.bill;
                    this.payment = response.data.body.payment;
                    this.transaction = response.data.body.transaction;
                    this.showReverse = response.data.body.showReverse;
                    this.reverseTimeout = response.data.body.reverseTimeout;

                    if (this.bill.state === 'GENERATING-TOKEN') {
                        this.countDown = 30;
                        this.startCountDown();
                    }
                }

            }).finally(() => {
                this.loading = false;
            });


        },
        startCountDown() {
            if (this.countDown > 0) {
                setTimeout(() => {
                    this.countDown -= 1;
                    this.startCountDown();
                }, 1000);

            } else {

                if (!this.loading && !this.done) {
                    this.submit();
                }
            }
        },
    },

    mounted() {
        this.submit();
    }
}
</script>

<style scoped>

</style>
